/**
 * Facade for agent knowledge retrieval defaults under `botSetting`.
 *
 * Import the default export only from feature code, e.g.:
 *   import agentKbRetrieval from '@/views/botSetting/agentKnowledgeRetrieval';
 *
 * Keeps defaults and API-shape helpers colocated with the feature instead of `src/constants`.
 */

import {
  AGENT_KB_PUBLIC_FLAT_KEYS,
  buildDefaultAgentKbSettingsRow,
  DEFAULT_PER_KB_CORRELATION_DECIMAL,
  EDIT_KNOWLEDGE_FORM_DEFAULTS,
  isValidRetrivalAlgEnum,
  KB_SETTINGS_DEFAULTS,
  RETRIEVAL_ALG_NUM,
  stripCatalogRetrievalFieldsFromKnowledgeItem
} from './config';

const agentKbRetrieval = Object.freeze({
  alg: RETRIEVAL_ALG_NUM,
  perKb: KB_SETTINGS_DEFAULTS,
  editFormDefaults: EDIT_KNOWLEDGE_FORM_DEFAULTS,
  defaultCorrelation01: DEFAULT_PER_KB_CORRELATION_DECIMAL,
  publicFlatKeys: AGENT_KB_PUBLIC_FLAT_KEYS,
  isValidAlg: isValidRetrivalAlgEnum,
  buildDefaultSettingsRow: buildDefaultAgentKbSettingsRow,
  stripCatalogFieldsFromListItem: stripCatalogRetrievalFieldsFromKnowledgeItem
});

export default agentKbRetrieval;
